/** Modern Slavery Statement section content — UK TO MARS LTD */

export const modernSlaveryIntro = [
  "This statement is made with reference to Section 54 of the Modern Slavery Act 2015 and sets out the steps UK TO MARS LTD has taken, and continues to take, to help prevent modern slavery and human trafficking within our business operations and supply chain.",
  "Although UK TO MARS LTD is not currently legally required to publish a Modern Slavery Statement under the turnover thresholds of the Modern Slavery Act 2015, we are committed to operating ethically, responsibly, and transparently across our wholesale, export, and logistics activities. We publish this statement voluntarily as part of our commitment to responsible business conduct.",
];

export const modernSlaverySections = [
  {
    title: "Our Business",
    paragraphs: [
      "UK TO MARS LTD is a UK-based FMCG wholesaler and exporter supplying British and selected European products to customers in the UK and international markets.",
      "Our activities include:",
    ],
    bullets: [
      "wholesale supply of FMCG products;",
      "export coordination;",
      "consolidation and loading services;",
      "logistics support;",
      "international trade and distribution;",
      "sourcing products from UK and European supplier networks.",
    ],
    closing: [
      "We work with suppliers, logistics providers, freight forwarders and business customers across multiple markets, and recognise the importance of maintaining ethical standards throughout our operations.",
    ],
  },
  {
    title: "Our Commitment",
    paragraphs: [
      "UK TO MARS LTD has a zero-tolerance approach to modern slavery, forced labour, servitude, child labour and human trafficking.",
      "We are committed to:",
    ],
    bullets: [
      "acting ethically and with integrity in all business dealings;",
      "promoting fair and lawful working practices;",
      "building responsible supplier relationships;",
      "helping reduce the risk of exploitation within our supply chain;",
      "complying with applicable UK laws and regulations.",
    ],
    closing: [
      "We expect our suppliers, contractors, logistics providers and business partners to operate with the same commitment to ethical business practices.",
    ],
  },
  {
    title: "Our Supply Chain",
    paragraphs: ["Our supply chain includes:"],
    bullets: [
      "UK wholesalers;",
      "manufacturers;",
      "distributors;",
      "importers;",
      "logistics providers;",
      "warehousing partners;",
      "freight forwarders;",
      "packaging and service providers.",
    ],
    closing: [
      "Most of our direct suppliers are based in the United Kingdom and Europe. We aim to work with businesses that operate responsibly, lawfully, and ethically.",
    ],
  },
  {
    title: "Due Diligence & Supplier Expectations",
    paragraphs: [
      "UK TO MARS LTD takes reasonable steps to assess and monitor supplier relationships and to reduce the risk of modern slavery within our operations and supply chain.",
      "Our approach includes:",
    ],
    bullets: [
      "working with established and reputable suppliers;",
      "reviewing supplier credibility and business reputation;",
      "requesting supplier information where relevant;",
      "expecting suppliers to comply with applicable employment and labour laws;",
      "monitoring supplier relationships and commercial conduct;",
      "reviewing any concerns raised regarding unethical practices.",
    ],
    closing: [
      "Where serious concerns regarding slavery, human trafficking or unethical labour practices are identified, we will review, suspend, or terminate supplier relationships as required.",
    ],
  },
  {
    title: "Recruitment & Employment Practices",
    paragraphs: [
      "We are committed to fair and lawful recruitment practices.",
      "Our employment practices include:",
    ],
    bullets: [
      "verifying eligibility to work in the UK;",
      "providing fair working conditions;",
      "supporting equal opportunities and non-discrimination;",
      "complying with applicable employment legislation;",
      "preventing unlawful or exploitative working practices.",
    ],
    closing: [
      "We do not engage in or support forced labour, involuntary labour, or child labour in any form.",
    ],
  },
  {
    title: "Whistleblowing & Reporting Concerns",
    paragraphs: [
      "We encourage employees, suppliers, contractors, and business partners to report any concerns relating to unethical behaviour, exploitation, modern slavery, or human trafficking.",
      "All concerns raised will be treated seriously and reviewed by management. We are committed to promoting an environment where concerns can be raised without fear of retaliation or unfair treatment.",
    ],
    whistleblowingEmail: true,
  },
  {
    title: "Risk Assessment",
    paragraphs: [
      "We recognise that modern slavery risks can exist within global supply chains and international trade sectors.",
      "Areas considered when assessing potential risk include:",
    ],
    bullets: [
      "supplier location and sourcing markets;",
      "labour-intensive industries;",
      "logistics and transportation services;",
      "outsourced operational activities;",
      "higher-risk geographies.",
    ],
    closing: [
      "We continue to review our processes and relationships to help reduce potential risks where reasonably practicable.",
    ],
  },
  {
    title: "Training & Awareness",
    paragraphs: [
      "UK TO MARS LTD maintains awareness of modern slavery risks within the business.",
      "Management and relevant personnel are expected to:",
    ],
    bullets: [
      "remain aware of modern slavery risks;",
      "identify signs of unethical or exploitative practices;",
      "raise concerns through the appropriate channels;",
      "support ethical sourcing and responsible business conduct.",
    ],
    closing: [
      "As the business grows, we will continue improving internal awareness and understanding of modern slavery risks and prevention measures.",
    ],
  },
  {
    title: "Measuring Effectiveness",
    paragraphs: ["We monitor the effectiveness of our approach through:"],
    bullets: [
      "ongoing supplier relationship reviews;",
      "management oversight;",
      "monitoring concerns or complaints;",
      "reviewing operational practices on a regular basis.",
    ],
    closing: [
      "At the date of this statement, UK TO MARS LTD is not aware of any incidents of modern slavery or human trafficking within our business operations or direct supply chain.",
    ],
  },
  {
    title: "Approval",
    paragraphs: [
      "This statement has been approved by the Director of UK TO MARS LTD and will be reviewed annually to reflect business developments and any legal or regulatory changes.",
    ],
    approval: true,
  },
];
